const userOptions = [
  {
    id: 'Profile',
    title: 'Profile',
    path: '/profile',
  },
  {
    id: 'Resources',
    title: 'Resources',
    path: '/resources',
  },
  {
    id: 'Transactions',
    title: 'Transactions',
    path: '/transactions',
  },
  {
    id: 'Settings',
    title: 'Settings',
    path: '/settings',
  },
];
export default userOptions;
